import { forwardRef, memo, useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import classNames from "common/class-names";
import getSideNavListing from "common/get-side-nav-listing";

import SideNavDto, { AppSideNavDto, SideNavImperativeHandleDto } from "dto/components/app-side-nav-dto";

import AppLogoAtf from "assets/images/components/app-side-nav/logo-atf.svg";
import AppIconLeft from "assets/images/components/app-side-nav/icon-arrow-left.svg";
import AppIconRight from "assets/images/components/app-side-nav/icon-arrow-right.svg";
import AppLogoAtfNoText from "assets/images/components/app-side-nav/logo-atf-no-text.svg";

const AppSideNav = (props: AppSideNavDto, ref: React.ForwardedRef<SideNavImperativeHandleDto>) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [isOpen, setIsOpen] = useState(true);
	const [activeIndex, setActiveIndex] = useState<number>(0);
	const enrichedSideNav = useMemo(() => getSideNavListing(), []);

	//prettier-ignore
	const onHandleItemChange = useCallback((obj: SideNavDto, index: number) => {
        setActiveIndex(index);
        navigate(obj.path as string);
    }, [navigate]);

	const onHandleToggleSideNav = () => {
		const sideNav = document.getElementById("side-nav");

		if (sideNav) {
			sideNav.classList.toggle("app-side-nav--shrank");

			setIsOpen((prev) => !prev);
		}
	};

	useEffect(() => {
		/* Set Nav Background To Specify Position */
		let sideNavIndex = null;

		const mainIndex = enrichedSideNav.findIndex((o) => {
			const isMainPath = o.path === location.pathname;

			if (isMainPath) return true;
			else return false;
		});

		if (mainIndex > -1) {
			sideNavIndex = mainIndex;
		}

		if (sideNavIndex !== null) setActiveIndex(sideNavIndex);
	}, [enrichedSideNav, location]);

	return (
		<div id="side-nav" className="app-side-nav">
			<div className="side-nav">
				<div className="side-nav__header">
					<img src={isOpen ? AppLogoAtf : AppLogoAtfNoText} alt="logo" />
				</div>

				<nav className="side-nav__nav">
					<ul id="side-nav-item" className="side-nav__list">
						{enrichedSideNav.map((o, i) => {
							const Icon = o.icon;
							const activeItem = activeIndex === i;
							const sideNavWrapperClassNames = classNames({ "side-nav__wrapper": true, "side-nav__wrapper--active": activeItem });

							return (
								<li className="side-nav__item" key={i} title={o.label}>
									<button className="side-nav__button" type="button" onClick={() => onHandleItemChange(o, i)}>
										<div className={sideNavWrapperClassNames} data-content={o.label}>
											<div className="side-nav__icon">{Icon && <Icon />}</div>
											<p className="side-nav__label">{o.label}</p>
										</div>
									</button>
								</li>
							);
						})}
					</ul>
				</nav>
			</div>

			<div className="side-nav__action" onClick={onHandleToggleSideNav}>
				{!isOpen ? <img src={AppIconRight} alt="" className="side-nav__action-icon" /> : <img src={AppIconLeft} alt="" className="side-nav__action-icon" />}
			</div>
		</div>
	);
};

export default memo(forwardRef(AppSideNav));
